import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { LineItemModel } from './LineItem.model';
import { AdditionalFeeModel } from './AdditionalFee.model';
import { PriceModel } from './Price.model';
import { DiscountBenefitModel } from './DiscountBenefit.model';
export class ExpressModel {
  constructor(checkoutModel) {
    _defineProperty(this, "id", void 0);
    /**
     * @deprecated
     */
    _defineProperty(this, "cartId", void 0);
    _defineProperty(this, "purchaseFlowId", void 0);
    _defineProperty(this, "priceSummary", void 0);
    _defineProperty(this, "additionalFees", void 0);
    _defineProperty(this, "giftCardAmount", void 0);
    _defineProperty(this, "payNow", void 0);
    _defineProperty(this, "lineItems", void 0);
    _defineProperty(this, "deliveryMethodCode", void 0);
    _defineProperty(this, "currency", void 0);
    _defineProperty(this, "hasViolations", void 0);
    _defineProperty(this, "calculationErrors", void 0);
    _defineProperty(this, "taxExemptPrice", void 0);
    _defineProperty(this, "pricesIncludeTax", void 0);
    _defineProperty(this, "discountBenefits", void 0);
    _defineProperty(this, "priceVerificationToken", void 0);
    this.id = checkoutModel.id;
    this.cartId = checkoutModel.cartId;
    this.purchaseFlowId = checkoutModel.purchaseFlowId;
    this.priceSummary = checkoutModel.priceSummary;
    this.additionalFees = checkoutModel.additionalFees;
    this.giftCardAmount = checkoutModel.giftCardAmount;
    this.payNow = checkoutModel.payNow;
    this.lineItems = checkoutModel.lineItems;
    this.deliveryMethodCode = checkoutModel.deliveryMethodCode;
    this.currency = checkoutModel.currency;
    this.hasViolations = checkoutModel.hasViolations;
    this.calculationErrors = checkoutModel.calculationErrors;
    this.taxExemptPrice = checkoutModel.taxExemptPrice;
    this.pricesIncludeTax = checkoutModel.pricesIncludeTax;
    this.discountBenefits = checkoutModel.discountBenefits;
    this.priceVerificationToken = checkoutModel.priceVerificationToken;
  }
  static fromV1(sdkCheckout, modelContext) {
    var _sdkCheckout$payNow, _sdkCheckout$payNow2, _sdkCheckout$addition, _sdkCheckout$giftCard, _sdkCheckout$appliedD, _sdkCheckout$shipping, _ref, _sdkCheckout$taxSumma, _sdkCheckout$taxSumma2;
    return new ExpressModel({
      id: sdkCheckout._id,
      cartId: sdkCheckout.cartId,
      purchaseFlowId: sdkCheckout.purchaseFlowId,
      priceSummary: {
        delivery: getDeliveryPriceV1(sdkCheckout, modelContext),
        tax: PriceModel.fromV1((_sdkCheckout$payNow = sdkCheckout.payNow) == null ? void 0 : _sdkCheckout$payNow.tax, modelContext),
        discount: PriceModel.fromV1((_sdkCheckout$payNow2 = sdkCheckout.payNow) == null ? void 0 : _sdkCheckout$payNow2.discount, modelContext)
      },
      additionalFees: (_sdkCheckout$addition = sdkCheckout.additionalFees) == null ? void 0 : _sdkCheckout$addition.map(additionalFee => AdditionalFeeModel.fromV1(additionalFee, modelContext)),
      giftCardAmount: /* istanbul ignore next */sdkCheckout.giftCard ? PriceModel.fromV1((_sdkCheckout$giftCard = sdkCheckout.giftCard) == null ? void 0 : _sdkCheckout$giftCard.amount, modelContext) : undefined,
      payNow: PriceModel.fromV1(sdkCheckout.payNowTotalAfterGiftCard, modelContext),
      discountBenefits: (_sdkCheckout$appliedD = sdkCheckout.appliedDiscounts) == null ? void 0 : _sdkCheckout$appliedD.map(appliedDiscount => DiscountBenefitModel.fromV1(appliedDiscount, modelContext)),
      deliveryMethodCode: (_sdkCheckout$shipping = sdkCheckout.shippingInfo) == null || (_sdkCheckout$shipping = _sdkCheckout$shipping.selectedCarrierServiceOption) == null ? void 0 : _sdkCheckout$shipping.code,
      lineItems: (_ref = sdkCheckout.lineItems ?? /* istanbul ignore next */[]) == null ? void 0 : _ref.map(lineItem => LineItemModel.fromV1(lineItem, modelContext)),
      currency: sdkCheckout.currency,
      hasViolations: Boolean(sdkCheckout.violations && sdkCheckout.violations.length > 0),
      calculationErrors: sdkCheckout.calculationErrors,
      taxExemptPrice: (_sdkCheckout$taxSumma = sdkCheckout.taxSummary) != null && _sdkCheckout$taxSumma.totalExempt ? PriceModel.fromV1((_sdkCheckout$taxSumma2 = sdkCheckout.taxSummary) == null ? void 0 : _sdkCheckout$taxSumma2.totalExempt, modelContext) : undefined,
      pricesIncludeTax: sdkCheckout.taxIncludedInPrice
    });
  }
  static fromV2(cart, cartSummary, modelContext) {
    var _cartSummary$priceSum, _cartSummary$priceSum2, _cartSummary$priceSum3, _cartSummary$addition, _cartSummary$paymentS, _cartSummary$paymentS2, _cartSummary$discount, _cart$deliveryInfo, _cart$taxInfo, _cartSummary$taxSumma;
    return new ExpressModel({
      id: cart._id,
      cartId: undefined,
      purchaseFlowId: cart.purchaseFlowId,
      priceSummary: {
        delivery: PriceModel.fromV2((_cartSummary$priceSum = cartSummary.priceSummary) == null ? void 0 : _cartSummary$priceSum.delivery, modelContext),
        tax: PriceModel.fromV2((_cartSummary$priceSum2 = cartSummary.priceSummary) == null ? void 0 : _cartSummary$priceSum2.tax, modelContext),
        discount: PriceModel.fromV2((_cartSummary$priceSum3 = cartSummary.priceSummary) == null ? void 0 : _cartSummary$priceSum3.discount, modelContext)
      },
      additionalFees: (_cartSummary$addition = cartSummary.additionalFees) == null ? void 0 : _cartSummary$addition.map(additionalFee => AdditionalFeeModel.fromV2(additionalFee, modelContext)),
      giftCardAmount: PriceModel.fromV2(cartSummary == null || (_cartSummary$paymentS = cartSummary.paymentSummary) == null || (_cartSummary$paymentS = _cartSummary$paymentS.giftCards) == null || (_cartSummary$paymentS = _cartSummary$paymentS[0]) == null ? void 0 : _cartSummary$paymentS.redeemAmount, modelContext),
      payNow: PriceModel.fromV2((_cartSummary$paymentS2 = cartSummary.paymentSummary) == null ? void 0 : _cartSummary$paymentS2.payNow, modelContext),
      discountBenefits: (_cartSummary$discount = cartSummary.discounts) == null ? void 0 : _cartSummary$discount.flatMap(discount => (discount.benefits ?? /* istanbul ignore next */[]).map(benefit => DiscountBenefitModel.fromV2(discount, benefit, modelContext))),
      lineItems: (cart.lineItems ?? /* istanbul ignore next */[]).map(lineItem => LineItemModel.fromV2(lineItem, modelContext)),
      deliveryMethodCode: (_cart$deliveryInfo = cart.deliveryInfo) == null || (_cart$deliveryInfo = _cart$deliveryInfo.method) == null ? void 0 : _cart$deliveryInfo.code,
      pricesIncludeTax: (_cart$taxInfo = cart.taxInfo) == null ? void 0 : _cart$taxInfo.pricesIncludeTax,
      currency: cart.paymentInfo.currencyCode,
      hasViolations: Boolean(cartSummary.spiViolations && cartSummary.spiViolations.length > 0),
      calculationErrors: cartSummary.calculationErrors,
      taxExemptPrice: PriceModel.fromV2((_cartSummary$taxSumma = cartSummary.taxSummary) == null ? void 0 : _cartSummary$taxSumma.totalExempt, modelContext),
      priceVerificationToken: cartSummary.priceVerificationToken ?? undefined
    });
  }
}
function getDeliveryPriceV1(sdkCheckout, modelContext) {
  var _sdkCheckout$payNow3;
  if (sdkCheckout.taxIncludedInPrice) {
    var _sdkCheckout$shipping2, _sdkCheckout$shipping3;
    return (_sdkCheckout$shipping2 = sdkCheckout.shippingInfo) != null && (_sdkCheckout$shipping2 = _sdkCheckout$shipping2.selectedCarrierServiceOption) != null && (_sdkCheckout$shipping2 = _sdkCheckout$shipping2.cost) != null && _sdkCheckout$shipping2.price ? PriceModel.fromV1((_sdkCheckout$shipping3 = sdkCheckout.shippingInfo) == null || (_sdkCheckout$shipping3 = _sdkCheckout$shipping3.selectedCarrierServiceOption) == null || (_sdkCheckout$shipping3 = _sdkCheckout$shipping3.cost) == null ? void 0 : _sdkCheckout$shipping3.price, modelContext) : undefined;
  }
  return PriceModel.fromV1((_sdkCheckout$payNow3 = sdkCheckout.payNow) == null ? void 0 : _sdkCheckout$payNow3.shipping, modelContext);
}
//# sourceMappingURL=Express.model.js.map